import { clsx } from 'clsx'
import { type FC } from 'react'

import { Checkbox } from 'base-ui'

import { type BrandOption } from '../../../hooks/useMarketplacePartnerRegisterPageAutocompleteState'

type MarketplacePartnerRegisterPageAutocompleteOptionProps = {
  isHighlighted: boolean
  isSelected: boolean
  onClick: () => void
  option: BrandOption
  setRef: (el: HTMLLIElement | null) => void
}

export const MarketplacePartnerRegisterPageAutocompleteOption: FC<
  MarketplacePartnerRegisterPageAutocompleteOptionProps
> = ({ isHighlighted, isSelected, onClick, option, setRef }) => {
  return (
    <li
      className={clsx(
        'flex min-h-14 w-full items-center gap-2 px-4 py-3 text-left text-dark-primary-max hover:bg-light-brand-low',
        isHighlighted && 'bg-light-brand-low',
        !isHighlighted && 'bg-light-primary-low',
      )}
      ref={setRef}
    >
      <label
        className="flex w-full cursor-pointer items-center gap-2"
        htmlFor={option.value}
      >
        <Checkbox
          aria-labelledby={`${option.value}-text`}
          checked={isSelected}
          id={option.value}
          onChange={onClick}
        />
        <span
          className="flex w-full flex-col items-center tablet:flex-row tablet:justify-between tablet:gap-2"
          id={`${option.value}-text`}
        >
          <span>{option.label}</span>
        </span>
      </label>
    </li>
  )
}
